<template>
    <az-call-to-action dark
                       outline
                       @click="processarReenvioDocumentos"
                       cssClass="botao-participar"
                       class="no-mobile">
        Enviar Documentos
    </az-call-to-action>
</template>
<script>
import {mapActions, mapState} from 'vuex'
import {actionTypes} from "@/commons/constants";

export default {
  name: 'CredenciamentoFornecedorAcoesReenviarDocumentos',
  computed: {
    ...mapState(['licitacao', 'credenciamento'])
  },
  methods: {
    async processarReenvioDocumentos() {
      this.habilitarLoadingGlobal()
      this.setMensagemLoading('Enviando Documentos...')
      try {
        await this.reenviarDocumentos({credenciamentoId: this.licitacao.id, solicitacaoId: this.credenciamento.reenviarDocumentos.solicitacaoId})
        this.mostrarNotificacaoSucessoDefault()
        this.credenciamento.resetReenviarDocumentos()
        this.$root.$emit('documentosReenviadosComSucesso');
      } catch (e) {
        this.desabilitarLoadingGlobal()
      }
    },
    ...mapActions({
        reenviarDocumentos: actionTypes.CREDENCIAMENTO.SOLICITACAO.REENVIAR_DOCUMENTOS
    })
  }
}
</script>
<style lang="stylus">
.botao-participar
  padding 10px !important

.botao-participar.secondary
  color white !important
  border 1px solid white !important
  border-radius 3px !important
  background-color transparent !important

</style>
